import * as yup from 'yup';
import {
  addOptionalNullableToSchema,
  internationalStateSchema,
  optionalNullableNameSchema,
  phoneSchema,
  zipSchema,
} from '@common/schema';

export const contactInformationSchema = yup.object().shape({
  google_places_id: addOptionalNullableToSchema(yup.string()),

  street: optionalNullableNameSchema,
  suite: optionalNullableNameSchema,
  city: optionalNullableNameSchema,
  state: addOptionalNullableToSchema(internationalStateSchema),
  zip_code: addOptionalNullableToSchema(zipSchema),
  county: optionalNullableNameSchema,
  phone_number: addOptionalNullableToSchema(phoneSchema),
  mobile_phone_number: addOptionalNullableToSchema(phoneSchema),
});
